function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logo nexi_login");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Assets_icone",
  transform: "translate(-890.000000, -6395.000000)",
  fill: "#2D32AA"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo-nexi_login",
  transform: "translate(890.000000, 6395.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  points: "150.791485 48.0769231 162.5 48.0769231 162.5 1.42450142 150.791485 1.42450142"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-22"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.0862804,0.195186212 C11.8781417,0.195186212 0.304683054,4.13040808 0.304683054,4.13040808 L0.304683054,48.1397187 L12.4314473,48.1397187 L12.4314473,12.3615887 C12.4314473,12.3615887 16.7521631,10.5426506 23.0862804,10.5426506 C30.9280324,10.5426506 34.2066399,14.8423732 34.2066399,21.5014461 L34.2066399,48.1397187 L46.1702727,48.1397187 C46.1702727,47.4861926 46.1663275,22.1698296 46.1702727,21.5014461 C46.1702727,7.11317353 39.5416508,0.195186212 23.0862804,0.195186212",
  id: "Fill-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.427403,1.51929477 L132.961369,1.51929477 L121.990136,15.1678685 L115.970643,7.55356577 C112.956952,3.74096672 108.069123,1.51929477 103.228832,1.51929477 L96.1098294,1.51929477 L114.406988,24.602496 L95.4888646,48.1397385 L109.835953,48.1397385 L121.54473,33.6143819 L128.29427,42.1227021 C131.304214,45.9246038 136.183956,48.1397385 141.017934,48.1397385 L148.047974,48.1397385 L129.13202,24.2062995 L147.427403,1.51929477 Z",
  id: "Fill-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.6966231,10.1945919 C79.976402,10.1945919 84.3643825,12.6739897 86.1550809,16.9132924 L62.2759459,21.1557647 C63.5484504,14.0991086 68.5495053,10.1945919 74.6966231,10.1945919 M97.6334616,39.1922147 L89.7240505,32.739164 C87.213167,35.7092512 82.9261822,39.1999406 75.9677467,39.1999406 C70.5131981,39.1999406 65.5417317,36.1684429 63.2661757,31.1335777 L98.8487616,24.8308835 C98.8487616,21.3401941 98.1625047,18.0143225 96.9152491,15.0000594 C93.2809875,6.23896593 84.8839572,0.107428685 74.7025408,0.107428685 C61.0138961,0.107428685 50.55632,9.89566165 50.55632,24.8308835 C50.55632,39.1880547 60.797308,49.5531498 75.9677467,49.5531498 C87.2772755,49.5531498 94.0765247,43.6480388 97.6334616,39.1922147",
  id: "Fill-6"
})))));

var SvgLogoNexi = function SvgLogoNexi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "163px",
    height: "50px",
    viewBox: "0 0 163 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoNexi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoNexi.45c6840e.svg";
export { ForwardRef as ReactComponent };